import { connectFela } from '../../dependencies';
import ExportFooter from './ExportFooter';
import * as styles from './ExportFooter.styles';

export default connectFela(styles)(ExportFooter);
